export function contactUs(subject = '', text = '') {
  window.$crisp.push(['do', 'chat:open']);
}
